import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from '../hooks/useTranslation';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header cartItemCount={0} onCartClick={() => {}} onOrderClick={() => {}} />
      
      <div className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="mb-8 hover:bg-gray-100"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('backToHome')}
          </Button>

          <h1 className="text-5xl font-bold text-black mb-8">{t('privacyPolicyTitle')}</h1>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppIntroTitle')}</h2>
              <p>{t('ppIntroText')}</p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppInfoCollectTitle')}</h2>
              <p className="mb-3">{t('ppInfoCollectText')}</p>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('ppInfoItem1')}</li>
                <li>{t('ppInfoItem2')}</li>
                <li>{t('ppInfoItem3')}</li>
                <li>{t('ppInfoItem4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppHowUseTitle')}</h2>
              <p className="mb-3">{t('ppHowUseText')}</p>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('ppUseItem1')}</li>
                <li>{t('ppUseItem2')}</li>
                <li>{t('ppUseItem3')}</li>
                <li>{t('ppUseItem4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppDataProtectionTitle')}</h2>
              <p>{t('ppDataProtectionText')}</p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppCookiesTitle')}</h2>
              <p>{t('ppCookiesText')}</p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppYourRightsTitle')}</h2>
              <p className="mb-3">{t('ppYourRightsText')}</p>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('ppRightItem1')}</li>
                <li>{t('ppRightItem2')}</li>
                <li>{t('ppRightItem3')}</li>
                <li>{t('ppRightItem4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('ppContactTitle')}</h2>
              <p>{t('ppContactText')}</p>
              <div className="space-y-2 mt-4">
                <p className="font-semibold">Liepu iela 9, Liepāja, Latvija</p>
                <p><a href="tel:+37128717331" className="text-blue-600 underline">+371 28717331</a></p>
                <p><a href="mailto:ordersmikado@gmail.com" className="text-blue-600 underline">ordersmikado@gmail.com</a></p>
              </div>
            </section>

            <section className="pt-6 border-t-2 border-gray-200">
              <p className="text-sm text-gray-600">{t('ppLastUpdated')}</p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;